const TaskShippingType = {
    COURIER: 'COURIER',
    PERSONAL_COLLECTION: 'PERSONAL_COLLECTION'
};

export {TaskShippingType};
